import { __rest, __assign } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';

var TriangleDotSolidIcon = function (_a) {
    var title = _a.title, props = __rest(_a, ["title"]);
    return (jsxs("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", "data-ui-icon": true }, props, { children: [title ? jsx("title", { children: title }) : null, jsx("path", { d: "M11.826 7.75a.214.214 0 00.348 0l3.79-5.44c.093-.132-.006-.31-.173-.31H8.209c-.167 0-.266.178-.174.31l3.791 5.44zM10.5 19.2c0-.11.09-.2.2-.2h2.6c.11 0 .2.09.2.2v2.6a.2.2 0 01-.2.2h-2.6a.2.2 0 01-.2-.2v-2.6zM10.5 14.2c0-.11.09-.2.2-.2h2.6c.11 0 .2.09.2.2v2.6a.2.2 0 01-.2.2h-2.6a.2.2 0 01-.2-.2v-2.6zM10.5 9.2c0-.11.09-.2.2-.2h2.6c.11 0 .2.09.2.2v2.6a.2.2 0 01-.2.2h-2.6a.2.2 0 01-.2-.2V9.2z", fill: "currentColor" })] })));
};

export { TriangleDotSolidIcon };
//# sourceMappingURL=TriangleDotSolidIcon.js.map
